'use strict';

define('vb/binding/legacyExpressionEvaluator',[], () => {
  const rethrowWithExpression = (e, expressionText) => {
    throw new Error(`${e.message} in expression "${expressionText}"`);
  };

  /**
   * Legacy sample non-CSP expression evaluator.
   * Instances should only be used as arguments to
   * Config.setFallbackExpressionEvaluator(...) for existing applications that
   * have not yet transitioned to fully support CSP-compliant expression policies.
   */
  class LegacyExpressionEvaluator {
    /**
     * Creates legacy generic expression evaluator.
     * @param {string} expressionText
     * @return {Function}
     */
    createGenericExpressionEvaluator(expressionText) {
      try {
        /* jslint evil:true */
        // eslint-disable-next-line no-new-func
        return new Function('context', 'with(context){return ' + expressionText + ';}');
      } catch (e) {
        return rethrowWithExpression(e, expressionText);
      }
    }

    /**
     * Creates legacy binding expression evaluator.
     * @param {string} expressionText
     * @return {Function}
     */
    createBindingExpressionEvaluator(expressionText) {
      try {
        /* jslint evil:true */
        // eslint-disable-next-line no-new-func
        return new Function(
          '$context',
          'with($context){with($data||{}){return ' + expressionText + ';}}'
        ); // binding expression evaluation
      } catch (e) {
        return rethrowWithExpression(e, expressionText);
      }
    }

    /**
     * Creates legacy replacement expression evaluator for extend.
     * @param {string} expressionText
     * @return {Function}
     */
    createReplacementEvaluatorForExtend(expressionText) {
      try {
        /* jslint evil:true */
        // eslint-disable-next-line no-new-func
        return new Function(
          '$context',
          '$element',
          'with($context.$data||{}){with($context){return ' + expressionText + '}}'
        ); // binding expression evaluation
      } catch (e) {
        return rethrowWithExpression(e, expressionText);
      }
    }
  }

  return LegacyExpressionEvaluator;
});

